import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { id: "screenfull" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("svg", {
  class: "icon",
  "aria-hidden": "true",
  "font-size": "40px"
}, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#iconshiliangzhinengduixiang1" })
], -1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("svg", {
  class: "icon",
  "aria-hidden": "true",
  "font-size": "40px"
}, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#iconshiliangzhinengduixiang1" })
], -1)
const _hoisted_5 = [
  _hoisted_4
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.isFullscreen)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.click && _ctx.click(...args)))
        }, _hoisted_3))
      : (_openBlock(), _createElementBlock("div", {
          key: 1,
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.click && _ctx.click(...args)))
        }, _hoisted_5))
  ]))
}